function updateNodeValue(node, attrName, value) {
  if (!node) return null;
  const previous = node.getAttribute(attrName);
  if (value !== null && value !== undefined) {
    node.setAttribute(attrName, value);
  }
  return previous;
}

function getOrCreateMeta(selector, attrName, attrValue) {
  let node = document.head.querySelector(selector);
  if (!node) {
    node = document.createElement('meta');
    node.setAttribute(attrName, attrValue);
    document.head.appendChild(node);
  }
  return node;
}

export function applyPageMetadata({
  title,
  description,
  canonicalUrl,
  ogTitle,
  ogDescription,
}) {
  if (typeof document === 'undefined') return () => {};

  const previousTitle = document.title;
  const descriptionNode = getOrCreateMeta('meta[name="description"]', 'name', 'description');
  const ogTitleNode = getOrCreateMeta('meta[property="og:title"]', 'property', 'og:title');
  const ogDescriptionNode = getOrCreateMeta('meta[property="og:description"]', 'property', 'og:description');
  const canonicalNode = document.head.querySelector('link[rel="canonical"]');

  const previousDescription = updateNodeValue(descriptionNode, 'content', description);
  const previousOgTitle = updateNodeValue(ogTitleNode, 'content', ogTitle || title);
  const previousOgDescription = updateNodeValue(ogDescriptionNode, 'content', ogDescription || description);
  const previousCanonical = canonicalNode ? canonicalNode.getAttribute('href') : null;

  if (title) document.title = title;
  if (canonicalNode && canonicalUrl) canonicalNode.setAttribute('href', canonicalUrl);
  if (!canonicalNode && canonicalUrl) {
    const link = document.createElement('link');
    link.rel = 'canonical';
    link.href = canonicalUrl;
    document.head.appendChild(link);
  }

  return () => {
    document.title = previousTitle;
    if (descriptionNode && previousDescription !== null) descriptionNode.setAttribute('content', previousDescription);
    if (ogTitleNode && previousOgTitle !== null) ogTitleNode.setAttribute('content', previousOgTitle);
    if (ogDescriptionNode && previousOgDescription !== null) ogDescriptionNode.setAttribute('content', previousOgDescription);
    if (canonicalNode && previousCanonical !== null) canonicalNode.setAttribute('href', previousCanonical);
  };
}
